import React from 'react';
import { Container } from './Styled';
import builder from '../../../Application';
import { BuilderProvider } from '../../context/BuilderContext';
import SheetFlow from './SheetFlow/SheetFlow';
import FlowList from './flowList/FlowList';
import { Flow } from '../../../model/workflowEditor/flow/types';
import ItemManager from '../../system/itemManager/ItemManager';
const FlowItemManager = ItemManager<Flow>();

type FlowManagerProps = {
}

const FlowManager: React.FunctionComponent<FlowManagerProps> = () => {
  const [selectedFlow, setSelectedFlow] = React.useState<Flow | undefined | null>(null);

  const changeFlow = (flow: Flow | undefined | null) => {
    // TODO REFACTO HERE UGLY CODE
    if (flow && flow.id !== selectedFlow?.id) {
      builder.loadModel(flow.diagram)
      setSelectedFlow(flow)
    } else {
      setSelectedFlow({
        name: '',
        id: '',
        slots: [],
        diagram: {}
      });
      builder.newModel()
    }
  }

  const onChange = (flow: Flow) => {
    setSelectedFlow(flow)
  }

  const renderSheetFlow = () => {
      return <><SheetFlow flow={selectedFlow!} onChange={onChange}/></>
  }

  const renderMenu = () => {
    return <FlowList selectedFlowId={selectedFlow?.id} onSelect={changeFlow} />
  }

  return (
      <Container>
        <BuilderProvider value={{ builder: builder }}>
        <FlowItemManager
            Menu={renderMenu()}
            Content={renderSheetFlow()}
            selectedItem={selectedFlow}
        />
        </BuilderProvider>
      </Container>
  );
}

export default FlowManager;
